<template>
  <div :class="$style.base">
    <Flex
      v-if="!emailSent"
      :direction="'column'"
      :gap="2"
    >
      <Flex :direction="'column'">
        <BaseHeading
          size="xl"
          center
        >
          {{ $t('login.forgot_password') }}
        </BaseHeading>
        <BaseText center>
          {{ $t('forgot_password.description') }}
        </BaseText>
      </Flex>
      <BaseForm @submit="onSubmit">
        <Flex :direction="'column'">
          <BaseInput
            v-model="email"
            type="email"
            name="email"
            required
            v-test="'emailInput'"
          />
          <BaseButton
            :loading="isLoading"
            size="l"
            fullWidth
            submitForm
            v-test="'submit'"
          >
            {{ $t('forgot_password.reset_password') }}
          </BaseButton>
        </Flex>
      </BaseForm>
      <BaseText
        :routerLink="{ name: 'login' }"
        v-test="'backToLoginButton'"
      >
        {{ $t('forgot_password.back_to_login') }}
      </BaseText>
    </Flex>
    <Flex
      v-else
      :direction="'column'"
      :gap="2"
    >
      <BaseHeading
        size="xl"
        center
      >
        {{ $t('forgot_password.check_inbox') }}
      </BaseHeading>
      <Flex :direction="'column'">
        <BaseText
          center
          v-test="'emailSentInfo'"
        >
          {{ $t('forgot_password.email_info', { email }) }}
        </BaseText>
        <BaseButton
          :routerLink="{ name: 'login' }"
          v-test="'backToLoginButton'"
        >
          {{ $t('forgot_password.back_to_login') }}
        </BaseButton>
      </Flex>
    </Flex>
  </div>
</template>

<script lang="ts">
import useVuelidate from '@vuelidate/core';
import { defineComponent } from 'vue';
import axios from '@/axios';

export default defineComponent({
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      email: '',
      emailSent: false,
      isLoading: false,
    };
  },
  methods: {
    onSubmit() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.sendResetPasswordEmail();
      }
    },
    sendResetPasswordEmail() {
      this.isLoading = true;
      axios
        .get('/passwords/lost_password', { params: { email: this.email } })
        .then(() => {
          this.emailSent = true;
          this.isLoading = false;
        });
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  height: 100%;
  text-align: center;
}
</style>
